import React from 'react';
import {logout} from "../../actions/authorizationAction";
import connect from "react-redux/es/connect/connect";
import moment from "moment";
import StatusScreenApi from "../../apis/StatusScreenApi";
import {
    ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceLine, BarChart, Bar
} from 'recharts';
import { Detector } from "react-detect-offline";

class StatusScreen extends React.Component {

    state = {
        lastUpdate: null,
        supportersOnSite: null,
        currentDate: new Date(),
        systemOnline: false
    };

    updateInterval = null;
    statusInterval = null;

    componentDidMount() {
        this.loadData();
        this.updateInterval = window.setInterval(this.loadData, 20000);
        this.statusInterval = window.setInterval(this.getStatus, 1000);
    }

    loadData = () => {
        StatusScreenApi.basic()
            .then((response) => {
                if(response.status === 200 && response.data.success) {
                    this.setState({
                        lastUpdate: new Date(),
                        supportersOnSite: response.data.data.supportersOnSite,
                        supportersTicketDownloaded: response.data.data.supportersTicketDownloaded,
                        supportersTotal: response.data.data.supportersTotal,
                        shiftSlotsTotal: response.data.data.shiftSlotsTotal,
                        shiftOccupancy: response.data.data.shiftOccupancy,
                        nextRoutes: response.data.data.nextRoutes,
                        supportersAccountingState: response.data.data.supportersAccountingState,
                        systemOnline: true
                    });
                } else {
                    this.setState({
                        systemOnline: false
                    });
                }
            })
            .catch((e) => {
                this.setState({
                    systemOnline: false
                });
            });
    };

    getStatus = () => {
        this.setState({
            currentDate: new Date()
        });
    };

    componentWillUnmount() {
        if(this.updateInterval) window.clearInterval(this.updateInterval);
        if(this.statusInterval) window.clearInterval(this.statusInterval);
    }

    render() {
        return (
            <div className="StatusScreen container-fluid">
                <div className="row">
                    <div className="col-xs-2">
                        <h2>
                            {moment(this.state.currentDate).format('HH:mm:ss')}
                        </h2>
                    </div>
                    <div className="col-xs-8 text-center heading">
                        <h1>
                            SUPPORTER CARE CREW
                        </h1>
                        <div className="text-muted">
                            Stand: {this.state.lastUpdate ? moment(this.state.lastUpdate).format('DD.MM., HH:mm:ss') : 'nie'}
                        </div>
                    </div>
                    <div className="col-xs-2 text-right">
                        <Detector
                            render={({ online }) => (
                                <div className="m-t">
                                    Internet: {online ? <div className="label label-primary">online</div> : <div className="label label-danger">offline</div>}
                                </div>
                            )}
                        />
                        <div className="m-t-xs">
                            System: {this.state.systemOnline ? <div className="label label-primary">online</div> : <div className="label label-danger">offline</div>}
                        </div>
                    </div>
                </div>
                <div className="row m-t-xl boxes-1">
                    <div className="col-md-3">
                        <div className="ibox">
                            <div className="ibox-content text-center">
                                <h2>
                                    {this.state.supportersOnSite}
                                </h2>
                                <h3>
                                    Supporter:innen auf dem Platz
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="ibox">
                            <div className="ibox-content text-center">
                                <h2>
                                    {this.state.supportersTicketDownloaded}
                                </h2>
                                <h3>
                                    Tickets heruntergeladen
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="ibox">
                            <div className="ibox-content text-center">
                                <h2>
                                    {this.state.supportersTotal}
                                </h2>
                                <h3>
                                    Supporter:innen gesamt
                                </h3>
                            </div>
                        </div>
                    </div>
                    {/*<div className="col-md-3">
                        <div className="ibox">
                            <div className="ibox-content text-center">
                                <h2>
                                    {this.state.shiftSlotsTotal}
                                </h2>
                                <h3>
                                    Arbeitseinsätze gesamt
                                </h3>
                            </div>
                        </div>
                    </div>*/}
                    {this.state.supportersAccountingState ? (
                        <div className="col-md-3">
                            <div className="ibox">
                                <div className="ibox-content text-center">
                                    <h2>
                                        <small>{this.state.supportersAccountingState.uncool}/{this.state.supportersAccountingState.cool}/{this.state.supportersAccountingState.total}</small>
                                    </h2>
                                    <h3>
                                        Zahlungsstatus
                                    </h3>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className="row m-t-lg">
                    <div className="col-xs-6">
                        <ResponsiveContainer width='100%' aspect={2.0/1.0}>
                            <BarChart
                                data={this.state.shiftOccupancy}
                                margin={{
                                    top: 5, right: 30, left: 20, bottom: 5,
                                }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="i" tickFormatter={(i) => moment().startOf('hour').add('hour', i).format('HH:mm')}/>
                                <YAxis />
                                <ReferenceLine x={0} stroke="red" label="" />
                                <Tooltip />
                                <Legend />
                                <Bar type="monotone" dataKey="slots" name="Benötigt" fill="#FE6100"/>
                                <Bar type="monotone" dataKey="expected" name="Erwartet" fill="#FEE700"/>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                    <div className="col-xs-6">
                        {this.state.nextRoutes ? this.state.nextRoutes.map((timeSlot, tsI) => (
                            <div key={tsI} className="m-b-md">
                                <h3>{moment(timeSlot.date).format('DD.MM., HH:mm')}</h3>
                                {timeSlot.routes ? timeSlot.routes.map((route, rI) => (
                                    <div className="white-bg p-sm" key={`${tsI}-${rI}`}>
                                        <div className="pull-right">
                                            {route.expected}/{route.slots}
                                        </div>
                                        <strong>
                                            {route.name}
                                        </strong>
                                        {route.waitingSpot ? (
                                            <span>
                                                &nbsp;({route.waitingSpot})
                                            </span>
                                        ) : null}
                                    </div>
                                    )): null}
                            </div>
                        )): null}
                    </div>
                </div>
                {/*<div className="row">*/}
                    {/*<div className="col-xs-12 text-center m-t-xl">*/}
                        {/*<button type="default" onClick={this.props.handleLogout} className="btn btn-default">*/}
                            {/*Logout*/}
                        {/*</button>*/}
                    {/*</div>*/}
                {/*</div>*/}
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        handleLogout: () => {
            dispatch(logout())
        }
    }
};

export default connect(
    null,
    mapDispatchToProps
)(StatusScreen);
